import React, { useState } from "react";
import "./SideBarTest.css";
import { useEffect } from "react";
import { useAuth } from './../AuthContext';
import { isMobile } from 'react-device-detect';
import { GetUserPermissions, GetLastClickedMarker } from './../../js/Main'

var isMobileVersion = isMobile;

export default function SideBar({ setUpdateSidebar, setCancelUpdateSidebar, setSaveSidebar, isEditing, isActive, setIsActive, info }) {
  //const [isEditing, setIsEditing] = useState(false);
  //const [isMobileVersion, setIsMobileVersion] = useState(false);
  
  if (!(process.env.REACT_APP_IS_MOBILE === 'true')) {
    isMobileVersion = false;
  }
  if (isActive) {
    console.log("process.env.REACT_APP_IS_MOBILE = " + process.env.REACT_APP_IS_MOBILE);
    const info_side = isMobileVersion ? ".info-side-mobile" : ".info-side";
    console.log("info_side = " + info_side);
    const del = document.querySelector(info_side);
    del.classList.add("info__active");
    // del.innerHTML = "";
  }

  var isEditable = false;
  var departmentAccessArray = GetUserPermissions();
  // Сначала ищем универсальное разрешение "00=", как это сделано в PPManager.js
  // (PPPopupSetup). Раньше здесь бралась просто departmentAccessArray[0], т.е.
  // случайная первая запись массива, что могло дать неверный результат для
  // пользователей с несколькими подразделениями в permissions.
  const entry = departmentAccessArray.find(e => e.startsWith("00=")) || departmentAccessArray[0];
  if (entry) {
    const role_id = entry.split("=")[1];
      switch (role_id) {
        case '1':
        case '2':
          isEditable = true;
          break;
        case '3':
          isEditable = false;
          break;
      }
  }

  function callPrint() {
    // Создаем новое окно для печати
    var windowPrint = window.open(
      "",
      "",
      "left=50,top=50,width=800,height=640,toolbar=0,scrollbars=1,status=0"
    );

    // Вставляем стили печати (если есть) до содержимого
    var printCSS =
      '<link rel="stylesheet" href="css/sidebar.css" type="text/css" />';
    windowPrint.document.write(printCSS);

    var infoSideContent = document.querySelector(".sidebar").innerHTML;
    // Получаем содержимое блока .sidebar
    windowPrint.document.write(infoSideContent);
    // Вставляем содержимое блока .sidebar

    // Закрываем документ и запускаем диалоговое окно печати
   // windowPrint.document.close();
   // windowPrint.focus();
    setTimeout(function () {
      windowPrint.print();
      windowPrint.close();
    }, 1000); // Задержка в миллисекундах (1 секунда в данном случае)

  }

  const handleClick = (event) => {
    console.log("event");
    if (isActive) {
      const info_side = isMobileVersion ? ".info-side-mobile" : ".info-side";
      const del = document.querySelector(info_side);
      del.classList.remove("info__active");
      // del.innerHTML = "";

      /*if (isMobileVersion) {
        const marker = GetLastClickedMarker();
        if (marker) {
          setTimeout(() => marker.fire('click'), 150); // задержка чтобы сайдбар успел закрыться
        }
      }*/
    }
    setIsActive((current) => !current);
  };

  const handleEditClick = () => {
   // setIsEditing(true);
    setCancelUpdateSidebar(false);
    setSaveSidebar(false);
    setUpdateSidebar(true);
  };

  const handleSaveClick = () => {
    // Здесь можно добавить логику сохранения изменений
    //setIsEditing(false);
    setUpdateSidebar(false);
    //setCancelUpdateSidebar(true);
    setSaveSidebar(true);
  };

  const handleCancelClick = () => {
   // setIsEditing(false);
    setUpdateSidebar(false);
    setSaveSidebar(false);
    setCancelUpdateSidebar(true);
  };

  const btnStyle = (bg, color) => ({
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    background: bg,
    color: color,
    padding: '8px 16px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    userSelect: 'none',
    whiteSpace: 'nowrap'
  });

  //const { user } = useAuth();

  return (
  <div className={`sidebar ${isActive ? "sidebar__active" : ""}`}>
    <div onClick={handleClick} className="map-collapser"></div>
    
    <div className={`sidebar__update ${isActive ? "update__active" : ""}`}>
      {isEditing ? (
        <div className="update-buttons">
          <div onClick={handleSaveClick} style={btnStyle('#3b82f6', '#ffffff')}>
            Сохранить
          </div>
          <div onClick={handleCancelClick} style={btnStyle('#f5f5f5', '#374151')}>
            Отменить
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: '8px', paddingRight: '8px'}}>
          
          {/* Кнопка закрытия — слева */}
          <div onClick={handleClick} style={{ ...btnStyle('#f5f5f5', '#374151'), display: 'flex', alignItems: 'center', gap: '4px' }}>
            ✕
          </div>
        <div className="update-buttons">
          {!isMobileVersion && (
            <div  onClick={callPrint} style={btnStyle('#f5f5f5', '#374151')}>
              Печать
            </div>
          )}
          {isEditable && (
            <div onClick={handleEditClick} style={btnStyle('#f5f5f5', '#374151')}>
              Редактировать
            </div>
          )}
        </div>
        </div>
      )}
    </div>

    {!isMobileVersion 
      ? <div className="info-side"></div> 
      : <div className="info-side-mobile"></div>
    }
  </div>
);
}
